// import axios from "axios";
// import { renewToken } from "../services/auth.service";
// import * as MyStorage from "./myStorage";
// import config from "../config";

// // const ApiUrl = process.env.REACT_APP_API_URL;
// const ApiUrl = config().API_URL;
// // const partnerUrl = process.env.REACT_APP_PARTNER_URL;
// const partnerUrl = config().PARTNER_URL;
// /**
//  * Setup a axios intsance for whole application
//  * Here we setup basic config like API url and request headers
//  */
// const axiosInstance = axios.create({
//   baseURL: ApiUrl,
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//   },
// });

// export const axiosPartnerInstance = axios.create({
//   baseURL: partnerUrl,
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//     "connection-code": MyStorage.getCode(),
//     jwt: MyStorage.getAccessToken() + "." + MyStorage.getTokenForPartner()
//   }
// });

// export const axiosPublicInstance = axios.create({
//   baseURL: ApiUrl,
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//   },
// });

// export const axiosInstanceForMail = axios.create({
//   // baseURL: "https://mailtest.akead.link",
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//     Jwt: MyStorage.getLinkForMail(),
//   },
// });

// export const axiosInstanceForTvDashboard = axios.create({
//   baseURL: MyStorage.getLinkForTvDashboard(),
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//     jwt: MyStorage.getAccessToken() + "." + MyStorage.getTokenForTvDashboard()
//   },
// });

// /**
//  * Here we can handle API response and can modify
//  * before using it in recat application or component
//  *
//  * @param {API Response} response
//  * @returns Promise
//  */
// const handleResponse = (response) => {
//   return new Promise(async (resolve) => {
//     const resData = response.data;
//     return resolve(resData);
//   });
// };

// /**
//  * Here we can handle API response status code and error
//  * We can customized Error for our application
//  *
//  * @param {Object} data
//  * @returns
//  */

// /**
//  * This function is used to handle faild API response
//  * Here we can refresh token
//  *
//  * @param {Object} error
//  * @returns
//  */
// const handleErrorResponse = async (error) => {
//   // eslint-disable-next-line
//   const { config, response } = error;
//   const resData = response.data;
//   if (response.status === 400 && resData.error.message === "Expired Jwt") {
//     MyStorage.removeToken();
//     window.location.href = "/authentication";
//     return Promise.reject("Session Expired");
//   }
//   return Promise.reject(resData);
// };

// const handlePublicErrorResponse = async (error) => {
//   // eslint-disable-next-line
//   const { config, response } = error;
//   const resData = response.data;
//   return Promise.reject(resData);
// };

// /**
//  * We can intercept the outgoing Rest API request data here
//  * We can inlcude headers or can modify request body
//  *
//  * @param {Request} req
//  * @returns
//  */
// const handleRequest = async (req) => {
//   let { exp } = MyStorage.getTokenInfo();
//   if (
//     MyStorage.shouldTokenRenew(exp) &&
//     // req.url !== "/Membership/login" &&
//     req.url !== "Membership/login/v2" &&
//     req.url !== "/Membership/renewToken" &&
//     req.url !== "/Membership/renewPasswordMail"
//   ) {
//     await renewToken({ oldJwt: MyStorage.getAccessToken() }).then((res) => {
//       MyStorage.setToken(res?.jwt);
//       setTimeout(() => {
//         const channel = new BroadcastChannel("myChannel");
//         channel.postMessage("new token");
//       }, 1000);
//     });
//   }

//   let headers = req.headers;
//   if (
//     req.url.includes("Membership") &&
//     // req.url !== "/Membership/login" &&
//     req.url !== "/Membership/login/v2" &&
//     req.url !== "/Membership/renewToken" &&
//     req.url !== "/Membership/renewPasswordMail"
//   ) {
//     headers["application-jwt"] = MyStorage.getAccessToken();
//   }
//   // if (req.url.includes("https://mailtest.akead.link/")) {
//   //   headers[
//   //     "jwt"
//   //   ] = `${MyStorage.getAccessToken()}.${MyStorage.getTokenForMail()}`;
//   // }
//   if (req.url.includes("https://dashbordtvtest.akead.link")) {
//     headers[
//       "jwt"
//     ] = `${MyStorage.getAccessToken()}.${MyStorage.getTokenForTvDashboard()}`;
//     headers["connection-code"] = MyStorage.getCode();
//   }
//   if (req.url.includes("Admin")) {
//     headers[
//       "jwt"
//     ] = `${MyStorage.getAccessToken()}.${MyStorage.getServiceToken2(11).jwt}`;
//   }

//   req.headers = headers;
//   return req;
// };

// //Handle request error
// const handleRequestError = (error) => {
//   return Promise.reject(error);
// };

// //Request Interceptor
// axiosInstance.interceptors.request.use(handleRequest, handleRequestError);
// axiosPartnerInstance.interceptors.request.use(handleRequest, handleRequestError);
// axiosInstanceForTvDashboard.interceptors.request.use(handleRequest, handleRequestError);
// axiosInstanceForMail.interceptors.request.use(handleRequest, handleRequestError);

// //Response Interceptor
// axiosInstance.interceptors.response.use(handleResponse, handleErrorResponse);
// axiosPartnerInstance.interceptors.response.use(handleResponse, handleErrorResponse);
// axiosInstanceForMail.interceptors.response.use(handleResponse, handleErrorResponse);
// axiosInstanceForTvDashboard.interceptors.response.use(handleResponse, handleErrorResponse);

// axiosPublicInstance.interceptors.request.use((req) => {
//   let token = MyStorage.getAccessToken();
//   let headers = req.headers;
//   if (
//     req.url.includes("Membership") &&
//     // req.url !== "/Membership/login" &&
//     req.url !== "/Membership/login/v2" &&
//     req.url !== "/Membership/renewToken" &&
//     req.url !== "/Membership/renewPasswordMail"
//   ) {
//     headers["application-jwt"] = token;
//   }
//   return req;
// }, handleRequestError);

// axiosPublicInstance.interceptors.response.use(
//   handleResponse,
//   handlePublicErrorResponse
// );

// export default axiosInstance;

import axios from "axios";

import { renewToken } from "../services/auth.service";
import * as MyStorage from "./myStorage";
import config from "../config";


const ApiUrl = config().API_URL;
const partnerUrl = config().PARTNER_URL;


/*
 * Ortak axios ayarları
 */
const defaultHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};


/*
 * Ana API
 */
const axiosInstance = axios.create({
  baseURL: ApiUrl,
  headers: defaultHeaders,
});


/*
 * PARTNER API
 *
 * DİKKAT:
 * JWT ve connection-code burada sabit verilmez.
 * Her request sırasında interceptor içinde okunur.
 */
export const axiosPartnerInstance = axios.create({
  baseURL: partnerUrl,
  headers: defaultHeaders,
});


/*
 * Public API
 */
export const axiosPublicInstance = axios.create({
  baseURL: ApiUrl,
  headers: defaultHeaders,
});


/*
 * Mail
 */
export const axiosInstanceForMail = axios.create({
  headers: defaultHeaders,
});


/*
 * TV Dashboard
 *
 * baseURL dinamik değişebiliyorsa bunu da request
 * sırasında vermek daha güvenlidir.
 */
export const axiosInstanceForTvDashboard = axios.create({
  headers: defaultHeaders,
});


/*
 * Response
 */
const handleResponse = (response) => {
  return response.data;
};


/*
 * Error response
 */
const handleErrorResponse = async (error) => {

  const response = error?.response;

  /*
   * Network error vb.
   * response olmayabilir.
   */
  if (!response) {
    return Promise.reject(error);
  }


  const resData = response?.data;


  if (
    response.status === 400 &&
    resData?.error?.message === "Expired Jwt"
  ) {

    MyStorage.removeToken();

    window.location.href = "/authentication";

    return Promise.reject(
      new Error("Session Expired")
    );
  }


  return Promise.reject(
    resData || error
  );
};


/*
 * Public error
 */
const handlePublicErrorResponse = async (error) => {

  const response = error?.response;

  if (!response) {
    return Promise.reject(error);
  }

  return Promise.reject(
    response?.data || error
  );
};


/*
 * GET requestleri için cache'i mümkün olduğunca
 * devre dışı bırak.
 *
 * NOT:
 * Backend'in de response'ta
 *
 * Cache-Control: no-store
 *
 * göndermesi en doğru çözümdür.
 */
const disableGetCache = (req) => {

  if (
    req?.method?.toLowerCase() === "get"
  ) {

    req.headers["Cache-Control"] =
      "no-cache, no-store, must-revalidate";

    req.headers["Pragma"] =
      "no-cache";

    req.headers["Expires"] =
      "0";
  }

  return req;
};


/*
 * Token yenileme
 */
const renewApplicationTokenIfNeeded =
  async (req) => {

    const tokenInfo =
      MyStorage.getTokenInfo?.();

    const exp =
      tokenInfo?.exp;


    if (
      exp &&
      MyStorage.shouldTokenRenew(exp) &&
      req.url !== "Membership/login/v2" &&
      req.url !== "/Membership/login/v2" &&
      req.url !== "/Membership/renewToken" &&
      req.url !== "/Membership/renewPasswordMail"
    ) {

      const res =
        await renewToken({
          oldJwt:
            MyStorage.getAccessToken(),
        });


      if (res?.jwt) {

        MyStorage.setToken(res.jwt);


        /*
         * Diğer browser tab'larına
         * yeni token bilgisini bildir.
         */
        try {

          const channel =
            new BroadcastChannel(
              "myChannel"
            );

          channel.postMessage(
            "new token"
          );

          channel.close();

        } catch (error) {

          console.warn(
            "BroadcastChannel error:",
            error
          );
        }
      }
    }
  };


/*
 * MAIN API REQUEST INTERCEPTOR
 *
 * User ve Connection gibi:
 *
 * /Admin/userList
 * /Admin/connectionList
 * /Admin/connection
 *
 * buradan geçer.
 */
const handleRequest = async (req) => {

  await renewApplicationTokenIfNeeded(
    req
  );


  req.headers =
    req.headers || {};


  disableGetCache(req);


  /*
   * Membership
   */
  if (
    req.url?.includes("Membership") &&
    req.url !== "Membership/login/v2" &&
    req.url !== "/Membership/login/v2" &&
    req.url !== "/Membership/renewToken" &&
    req.url !== "/Membership/renewPasswordMail"
  ) {

    req.headers["application-jwt"] =
      MyStorage.getAccessToken() || "";
  }


  /*
   * ADMIN
   *
   * Her request'te JWT ve connection-code
   * yeniden storage'dan okunuyor.
   */
  if (
    req.url?.includes("Admin")
  ) {

    const accessToken =
      MyStorage.getAccessToken?.() || "";


    const serviceTokenData =
      MyStorage.getServiceToken2?.(11);


    const serviceJwt =
      serviceTokenData?.jwt || "";


    if (
      accessToken &&
      serviceJwt
    ) {

      req.headers["jwt"] =
        `${accessToken}.${serviceJwt}`;

    } else {

      delete req.headers["jwt"];
    }


    /*
     * Connection her request'te güncel okunur.
     */
    const connectionCode =
      MyStorage.getCode?.();


    if (connectionCode) {

      req.headers["connection-code"] =
        connectionCode;

    } else {

      delete req.headers[
        "connection-code"
      ];
    }
  }


  return req;
};


/*
 * PARTNER REQUEST
 *
 * Burada özellikle ayrı interceptor kullanıyoruz.
 *
 * Çünkü Partner API'nin jwt'si:
 *
 * application token + partner token
 *
 * şeklinde oluşturuluyor.
 *
 * Genel Admin interceptor'ın bunu serviceToken(11)
 * ile ezmesini istemiyoruz.
 */
const handlePartnerRequest =
  async (req) => {

    await renewApplicationTokenIfNeeded(
      req
    );


    req.headers =
      req.headers || {};


    disableGetCache(req);


    const accessToken =
      MyStorage.getAccessToken?.() || "";


    const partnerToken =
      MyStorage.getTokenForPartner?.() ||
      "";


    if (
      accessToken &&
      partnerToken
    ) {

      req.headers["jwt"] =
        `${accessToken}.${partnerToken}`;

    } else {

      delete req.headers["jwt"];
    }


    /*
     * En önemli düzeltmelerden biri:
     *
     * connection-code artık axios.create()
     * sırasında sabitlenmiyor.
     *
     * Her request'te tekrar okunuyor.
     */
    const connectionCode =
      MyStorage.getCode?.();


    if (connectionCode) {

      req.headers["connection-code"] =
        connectionCode;

    } else {

      delete req.headers[
        "connection-code"
      ];
    }


    return req;
  };


/*
 * MAIL REQUEST
 */
const handleMailRequest =
  async (req) => {

    req.headers =
      req.headers || {};


    disableGetCache(req);


    const mailJwt =
      MyStorage.getLinkForMail?.();


    if (mailJwt) {

      req.headers["Jwt"] =
        mailJwt;

    } else {

      delete req.headers["Jwt"];
    }


    return req;
  };


/*
 * TV DASHBOARD REQUEST
 */
const handleTvDashboardRequest =
  async (req) => {

    req.headers =
      req.headers || {};


    disableGetCache(req);


    /*
     * Dashboard URL de runtime'da
     * değişebiliyorsa her request'te
     * güncel değer kullanılmalı.
     */
    const tvBaseUrl =
      MyStorage.getLinkForTvDashboard?.();


    if (tvBaseUrl) {
      req.baseURL = tvBaseUrl;
    }


    const accessToken =
      MyStorage.getAccessToken?.() || "";


    const tvToken =
      MyStorage.getTokenForTvDashboard?.() ||
      "";


    if (
      accessToken &&
      tvToken
    ) {

      req.headers["jwt"] =
        `${accessToken}.${tvToken}`;

    } else {

      delete req.headers["jwt"];
    }


    const connectionCode =
      MyStorage.getCode?.();


    if (connectionCode) {

      req.headers["connection-code"] =
        connectionCode;

    } else {

      delete req.headers[
        "connection-code"
      ];
    }


    return req;
  };


/*
 * PUBLIC REQUEST
 */
const handlePublicRequest =
  async (req) => {

    req.headers =
      req.headers || {};


    disableGetCache(req);


    const token =
      MyStorage.getAccessToken?.();


    if (
      req.url?.includes("Membership") &&
      req.url !== "Membership/login/v2" &&
      req.url !== "/Membership/login/v2" &&
      req.url !== "/Membership/renewToken" &&
      req.url !== "/Membership/renewPasswordMail"
    ) {

      if (token) {

        req.headers[
          "application-jwt"
        ] = token;

      } else {

        delete req.headers[
          "application-jwt"
        ];
      }
    }


    return req;
  };


/*
 * Request Error
 */
const handleRequestError = (
  error
) => {

  return Promise.reject(error);

};


/*
 * ===============================
 * REQUEST INTERCEPTORS
 * ===============================
 */

axiosInstance.interceptors.request.use(
  handleRequest,
  handleRequestError
);


axiosPartnerInstance.interceptors.request.use(
  handlePartnerRequest,
  handleRequestError
);


axiosInstanceForTvDashboard.interceptors.request.use(
  handleTvDashboardRequest,
  handleRequestError
);


axiosInstanceForMail.interceptors.request.use(
  handleMailRequest,
  handleRequestError
);


axiosPublicInstance.interceptors.request.use(
  handlePublicRequest,
  handleRequestError
);


/*
 * ===============================
 * RESPONSE INTERCEPTORS
 * ===============================
 */

axiosInstance.interceptors.response.use(
  handleResponse,
  handleErrorResponse
);


axiosPartnerInstance.interceptors.response.use(
  handleResponse,
  handleErrorResponse
);


axiosInstanceForMail.interceptors.response.use(
  handleResponse,
  handleErrorResponse
);


axiosInstanceForTvDashboard.interceptors.response.use(
  handleResponse,
  handleErrorResponse
);


axiosPublicInstance.interceptors.response.use(
  handleResponse,
  handlePublicErrorResponse
);


export default axiosInstance;